import React from "react";
import { useAuth } from "@/auth/AuthContext";

export default function AgencyProfile() {
  const { user } = useAuth();
  const initials = (user?.name || "A").split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

  return (
    <div data-testid="agency-profile">
      <h1 className="ag-h1 ag-entrance" style={{ fontSize: 36, marginBottom: 30 }}>Profile</h1>
      <div className="ag-card ag-entrance-2" style={{ maxWidth: 620 }}>
        <div style={{ display: "flex", gap: 20, alignItems: "center", marginBottom: 26 }}>
          <div className="ag-avatar ag-avatar-lg" style={{ display: "grid", placeItems: "center", background: "#0C0C0C", color: "#FFC817", font: "600 24px Montserrat" }}>{initials}</div>
          <div>
            <div className="ag-h2" style={{ fontSize: 24 }}>{user?.name}</div>
            <div className="ag-small">{user?.email}</div>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, borderTop: "1px solid var(--line)", paddingTop: 22 }}>
          <Row label="Account type" value="Partner Agency" />
          <Row label="Access" value="Portal only" />
          <Row label="Managed by" value="NJM Productions" />
          <Row label="Sign-in" value="Email & password" />
        </div>
        <p className="ag-small" style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid var(--line)" }}>
          Your agency details and project access are managed by your NJM production lead. Need a change? Reach out to your lead from any project's Open items.
        </p>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div>
      <div className="ag-label" style={{ marginBottom: 6 }}>{label}</div>
      <div className="ag-body" style={{ fontWeight: 600, fontSize: 13 }}>{value}</div>
    </div>
  );
}
